import React from "react";

import ListingContent from "../listingContent";
import JobsListing from "../jobsListing";

const Jobs = ({ isExpand, onClick, isActive, list, addToFavorite, removeFavorite, count }) => {
  return (
    <>
      {list?.length ? (
        <>
          {isExpand ? (
            <>{list?.length ? <JobsListing addToFavorite={addToFavorite} removeFavorite={removeFavorite} isExpand list={list} /> : null}</>
          ) : (
            <ListingContent title="Jobs" count={count || ""} onClick={onClick} isActive={isActive}>
              {list?.length ? <JobsListing removeFavorite={removeFavorite} addToFavorite={addToFavorite} list={list} /> : null}
            </ListingContent>
          )}
        </>
      ) : null}
    </>
  );
};

export default Jobs;
